import React from 'react'

const Home = () => {
  return (
    <div>
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/App/component/Home/index.jsx